import { render } from "./concant.vue?vue&type=template&id=d27635ca&scoped=true"
import script from "./concant.vue?vue&type=script&lang=js"
export * from "./concant.vue?vue&type=script&lang=js"

import "./concant.vue?vue&type=style&index=0&id=d27635ca&scoped=true&lang=css"

import exportComponent from "D:\\boya_project\\boya_web_mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d27635ca"]])

export default __exports__